module.exports = __webpack_public_path__ + "static/media/5-a2_old.a3cccf58.jpg";